import { useState } from 'react';
import crypto from 'crypto-js';

const SsoHandler = () => {
    const [ssodata, setssodata] = useState('');
    const decript_data = async (payload, app) => {
        console.log(payload, app, 'payloadpayloadpayloadpayload');
        let ciphertext = await crypto.AES.decrypt(payload, app[0].key).toString(crypto.enc.Utf8);
        console.log('app[0].keyapp[0].keyapp[0].key', app[0].key)
        if (!ciphertext) {
            ciphertext = await crypto.AES.decrypt(payload, app[1].key).toString(crypto.enc.Utf8);
            console.log('app[0].keyapp[0].keyapp[0].key', app[0].key)
        }
        setssodata(ciphertext);
        console.log(ciphertext, 'decript_data');
    };
    const checkSSO = () => {
        const key = new Promise((resolve) => {
            const sso = [
                {
                    app_id: "66f169ac0c50d97941c02ea5", // Your AI App
                    key: "2dc40a46-021b-4925-852c-df6b1fbf1761",
                },
                {
                    app_id: "66224f9fde24a6c1353de932", // Super admin
                    key: "f69ff908-8607-40ec-9d7f-b0424ab6e8c5",
                },
            ];

            // decript_data("U2FsdGVkX19VqIamqITisev3GuIqKPG3wqJ1A3Dgk7n90fWOoXgwOya5+L0eTYHsWzSNQpmQhysbm48bb8pCfOBd3xONisufnyMCfanp2ZFL/J43OQ+JI4r29VRwiBm4KP79Se8/IiCBbT89f/AboOSbVK9TP8SVFP3f6HYdgnrulP4KITIRWnfCrRPF98hfNRKwrpi4MYEexX4EDsFvrBjW8w/uG4srWFg/5wHV7J1YEMI0BROVKkM1GdAWR9TGV05c8BqTclnoU4iS/CupMDia/iN5As1ADXULX8J0j+0=", sso);
            // app_id: "6785137161cd87dfcac59745-m5v2yc44",  
            // key: "80ae8912-8042-4cf4-9001-0ab088016c85",
            // ssokey:"8de703d9-910e-4966-8299-9d88d7f761f4"

            window.parent.postMessage({ message: 'REQUEST_USER_DATA' }, '*');
            const temp = window.addEventListener('message', ({ data }) => {
                if (data.message === 'REQUEST_USER_DATA_RESPONSE') {
                    const sso = [
                        {
                            app_id: "66f169ac0c50d97941c02ea5", // Your AI App
                            key: "2dc40a46-021b-4925-852c-df6b1fbf1761",
                        },
                        {
                            app_id: "66224f9fde24a6c1353de932", // Super admin
                            key: "f69ff908-8607-40ec-9d7f-b0424ab6e8c5",
                        },
                    ];
                    console.log(data.payload, sso, 'sso');
                    decript_data(data.payload, sso);
                } else {
                }
                // console.log(temp, 'temptemptemptemptemptemp')
            });
        });
    };
    return {
        SSO: ssodata,
        checkSSO: checkSSO,
    };
};
export default SsoHandler;